import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Toast from "../components/Toast";
import "./Home.css";

export default function HomePage() {
  const [email, setEmail] = useState("");
  const [toast, setToast] = useState({ show: false, type: "info", message: "" });
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setToast({ show: true, type: "error", message: "Please enter your email" });
      setTimeout(() => setToast({ show: false }), 2500);
    } else {
      localStorage.setItem("userEmail", email); // save for next pages
      setToast({ show: true, type: "success", message: "Login Successful!" });
      setTimeout(() => {
        setToast({ show: false });
        navigate("/success");
      }, 1500);
    }
  };

  return (
    <div className="home-container">
      <Toast show={toast.show} type={toast.type} message={toast.message} />
      <form onSubmit={handleSubmit} className="home-form">
        <h1>Login with your Email</h1>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Submit</button>
      </form>
    </div>
  );
}
